'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var palette = theme.palette;


    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            width: theme.width,
            height: theme.height,
            background: theme.background
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _aphroditeJss = require('aphrodite-jss');